<template>
	<div
		class=""
		:style="{
			marginTop: data.marginTop + 'px',
			paddingTop: data.paddingTop + 'px',
			paddingLeft: data.paddingLeft + '%',
			paddingRight: data.paddingRight + '%',
		}"
	>
		<div class="" v-if="data.content && data.data.length > 0">
			<div class="content_img">
				<video width="100%" controls v-for="(item, index) in data.data" :key="index" :poster="item.url">
					<source :src="data.content" type="video/mp4" />
					您的浏览器不支持 HTML5 video 标签。
				</video>
			</div>
		</div>

		<div class="" v-else>
			<div class="content_img">
				<video width="100%" controls poster="../../assets/images/video_poster.png">
					<source src="" type="video/mp4" />
					您的浏览器不支持 HTML5 video 标签。
				</video>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'videoAndText',
	props: ['data'],
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/curriculum.scss';
.content_text {
	white-space: pre-line;
}
</style>